import {Component, OnInit, HostListener, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {FarmUserServiceService} from '@services/farm-user-service.service';
import {UserService} from '@services/user.service';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-farm-user-list',
    templateUrl: './farm-user-list.component.html',
    styleUrl: './farm-user-list.component.scss'
})
export class FarmUserListComponent implements OnInit, OnDestroy {
    public data: any[] = [];
    public name: string = '';
    totalRecords: number = 0;
    pageSize: number = 10;
    currentPage: number = 1;
    public loading = true;
    public userDetail: any;
    private deleteUserSubscription: any;

    public activeActionMenu: string | null = null;

    public displayUserDialog: boolean = false;
    public selectedUser: any = null;

    public displayDeleteDialog: boolean = false;
    public selectedUserId: number = 0;

    constructor(
        private farmUserService: FarmUserServiceService,
        private userService: UserService,
        private router: Router,
        private toastr: ToastrService
    ) {}

    ngOnInit() {
        this.userDetail = JSON.parse(localStorage.getItem('UserDetail'));
        this.getUserList();
    }

    getUserList(name: string = '') {
        this.loading = true;
        this.farmUserService
            .getFarmUserList(
                this.userDetail.id,
                name,
                this.currentPage,
                this.pageSize
            )
            .subscribe((result) => {
                console.log(result.farmUsers);
                this.totalRecords = result.totalRecords;
                this.data = result.farmUsers;
                this.loading = false;
            });
    }

    filterUser(): void {
        this.getUserList(this.name);
    }

    onPageChange(event: any) {
        this.currentPage = event.page + 1; // PrimeNG paginator starts from 0
        this.getUserList();
    }

    // === Dropdown menu methods (commit 1) ===
    toggleActionsMenu(userId: string) {
        this.activeActionMenu =
            this.activeActionMenu === userId ? null : userId;
    }

    @HostListener('document:click', ['$event'])
    closeActionMenuOnClickOutside(event: Event) {
        const target = event.target as HTMLElement;
        if (!target.closest('.smart-actions-dropdown')) {
            this.activeActionMenu = null;
        }
    }

    deleteUser(user: any) {
        this.selectedUserId = user.id;
        this.displayDeleteDialog = true;
        this.activeActionMenu = null;
    }

    deleteItem() {
        if (this.selectedUserId) {
            if (this.deleteUserSubscription) {
                this.deleteUserSubscription.unsubscribe();
            }
            this.deleteUserSubscription = this.userService
                .deleteUser(this.selectedUserId)
                .subscribe({
                    next: (response) => {
                        this.displayDeleteDialog = false;
                        this.selectedUserId = 0;
                        this.toastr.success('User deleted successfully.');
                        this.getUserList();
                    },
                    error: (error) => {
                        this.toastr.error(
                            error?.error?.message || 'Failed to delete user.'
                        );
                        this.displayDeleteDialog = false;
                        this.selectedUserId = 0;
                    }
                });
        }
    }

    viewUserDetails(user: any) {
        this.activeActionMenu = null;
        this.selectedUser = user;
        this.displayUserDialog = true;
    }

    closeDialog() {
        this.displayUserDialog = false;
        this.selectedUser = null;
    }

    editUser(user: any) {
        this.activeActionMenu = null;
        this.router.navigate(['/edit-user', user.id]);
    }

    ngOnDestroy() {
        if (this.deleteUserSubscription) {
            this.deleteUserSubscription.unsubscribe();
        }
    }
}
